import Component from '../core/Component.js'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries, CMS } from '../core/config'
import { scrollToElement } from '../services/Scroll'
import ScrollContainer from './ScrollContainer'

export const defaults = {
    cellSelector: '[data-ref="item"]',
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    autoplay: true,
    lazyLoad: 2,
    responzive: true,
    resize: true,
    contain: true,
    adaptiveHeight: true
}

export const STATES = {
    READY: 'is-ready',
    ACTIVE: 'is-active'
}

export default class CharitySlider extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            slider: null,
            indicator: null,
            navigation: null,
            links: [],
            items: [],
        }

        this.enquireLargeHandler = {
            match: () => this.match(),
            unmatch: () => this.unmatch()
        }

        this.enquireSmallWideHandler = {
            match: () => {
                this.flickity.options.draggable = false
                this.flickity.options.isDraggable = false
                this.flickity.isDraggable = false
            },
            unmatch: () => {
                this.flickity.options.draggable = true
                this.flickity.options.isDraggable = true
                this.flickity.isDraggable = true
            }
        }

        this.flickity = null
        this.index = 0
    }

    prepare() {
        if (CMS) {
            return
        }

        this.initSlider()

        this.ref.links.map(($element, index) => {
            $element.addEventListener('click', event => {
                event.preventDefault()
                this.flickity.select(index)
                scrollToElement(this.element)
            })

            if ($element.classList.contains(STATES.ACTIVE)) {
                this.moveIndicator(index)
            }
        })

        enquire.register(queries.largeMax, this.enquireLargeHandler)
        enquire.register(queries.smallWideMax, this.enquireSmallWideHandler)
    }

    destroy() {
        enquire.unregister(queries.largeMax, this.enquireLargeHandler)
        enquire.unregister(queries.smallWideMax, this.enquireSmallWideHandler)
        this.destroySlider()
    }

    match = () => {
        this.isMobile = true

        if (this.ref.navigation) {
            this.navigation = new ScrollContainer(this.ref.navigation)
            this.navigation.prepare()
        }
    }

    unmatch = () => {
        this.isMobile = false

        if (this.navigation) {
            this.navigation.destroy()
        }
    }

    initSlider() {
        if (!this.flickity) {
            this.element.classList.add(STATES.READY)

            this.flickity = new Flickity(this.ref.slider, this.options)

            this.flickity.on('change', ::this.changeSlide );
        }
    }

    destroySlider() {
        if (this.flickity) {
            this.element.classList.remove(STATES.READY)

            this.flickity.off('change', ::this.changeSlide );

            this.flickity.destroy()
            this.flickity = null
        }
    }

    changeSlide(index) {
        this.ref.links[index].classList.add(STATES.ACTIVE)
        this.ref.links[this.index].classList.remove(STATES.ACTIVE)

        this.moveIndicator(index)

        this.index = index
    }

    moveIndicator(index) {
        if (!this.isMobile) {
            this.ref.indicator.style.top = this.ref.links[index].getBoundingClientRect().top - this.element.getBoundingClientRect().top + 'px'
            this.ref.indicator.style.height = this.ref.links[index].getBoundingClientRect().height + 'px'
        }
    }
}